<button
  [class]="
    'pr-button ' +
    (clazz ? clazz + ' ' : '') +
    (display ? display + (variant ? '_' + variant : '') + ' ' : '') +
    (size ? size : '')
  "
  [class.rounded]="rounded"
  [class.mobile-icon]="mobileIcon"
  [type]="type"
  (click)="click($event)"
  [attr.title]="tooltip ? tooltip : null"
  [disabled]="disabled"
>
  @if (icon) {
    <pr-icon
      [name]="icon"
      [ngClass]="{ 'show-s': mobileIcon }"
      [attr.hasLabel]="label ? true : false"
      [width]="iconWidth"
      [height]="iconHeight"
      [viewBoxWidth]="iconViewBoxWidth"
      [viewBoxHeight]="iconViewBoxHeight"
    ></pr-icon>
  }
  @if (leftIcon) {
    <pr-icon
      [name]="leftIcon"
      [width]="iconWidth"
      [height]="iconHeight"
      [viewBoxWidth]="iconViewBoxWidth"
      [viewBoxHeight]="iconViewBoxHeight"
      class="right-icon"
    ></pr-icon>
  }
  @if (label) {
    <span
      class="pr-button-label"
      [ngClass]="{
        'hidden-s': hasIcon && mobileIcon,
        pln: icon && !mobileIcon,
        prn: rightIcon || leftIcon,
        mlxs: icon && !mobileIcon,
        mrxs: rightIcon || leftIcon,
      }"
      >{{ label }}</span
    >
  }
  @if (rightIcon) {
    <pr-icon
      [name]="rightIcon"
      [width]="iconWidth"
      [height]="iconHeight"
      [viewBoxWidth]="iconViewBoxWidth"
      [viewBoxHeight]="iconViewBoxHeight"
      class="right-icon"
    ></pr-icon>
  }
  @if (!label && !icon) {
    <div>
      <ng-content></ng-content>
    </div>
  }
</button>
